































import { durations, frequencies } from '@/config/subscriptions'
import { Component, Prop, Vue } from 'vue-property-decorator'
import BuilderDeviceHighlight from '@/components/builder/BuilderDeviceHighlight.vue'

@Component({
  components: {
    BuilderDeviceHighlight,
  },
})
export default class BuilderDeviceProfileSubscriptionsStub extends Vue {
  @Prop({ required: true, type: String }) color!: string

  @Prop({ default: true, type: Boolean }) blur!: boolean

  @Prop({ default: false, type: Boolean }) highlight!: boolean

  @Prop({ default: false, type: Boolean }) showSubscribeButton!: boolean

  @Prop({ default: null }) subscriptions!:
    | null
    | {
        id: number
        price: string
        duration: number
        frequency: number
      }[]

  get processedSubscriptions(): {
    id: number
    price: null | string
    duration: null | string
    frequency: null | string
  }[] {
    if (!this.subscriptions) {
      return Array.from(new Array(3)).map((_, i) => ({
        id: -i - 1,
        price: '10',
        duration: durations[1],
        frequency: frequencies[1],
      }))
    }

    return Array.from(new Array(3)).map((_, i) => {
      const item = this.subscriptions && this.subscriptions[i]

      if (!item) {
        return { id: -i - 1, price: '0', duration: '-', frequency: '-' }
      }

      return {
        id: item.id,
        price: item.price ? item.price : '0',
        duration: item.duration ? durations[item.duration] : '-',
        frequency: item.frequency ? frequencies[item.frequency] : '-',
      }
    })
  }
  get grayscale(): string {
    return this.blur ? 'filter grayscale' : ''
  }
}
